import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerDialogService } from '../../dialogs/customer/customer.service.dialog';
import { ItemSearchDialogService } from '../../dialogs/item-search/item-search.service.dialog';
import { InvoiceInterface } from '@contracts/interfaces/invoice.interface';
import { LineItem } from '@contracts/interfaces/lineitem.interface';
import { InvoicesService } from '../../services/invoices.service';
import { CustomerInterface } from '@contracts/interfaces/customer.interface';
import { CustomerService } from '../../services/customer.service';


@Component({
  selector: 'app-invoices-create',
  templateUrl: './invoices-create.component.html',
  styleUrls: ['./invoices-create.component.scss', '../invoice-table.scss']
})
export class InvoicesCreateComponent implements OnInit {

  public header = 'New Invoice';
  public type = '';

  public invoice: InvoiceInterface;
  public isLoaded = false;
  public prefillCustomer: CustomerInterface | null = null;
  public prefillLineDescription: string | null = null;
  public prefillLineItems: LineItem[] | null = null;
  public prefillNotes: string | null = null;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private invoiceService: InvoicesService
  ) { }

  ngOnInit(): void {

    const navigation = this.router.getCurrentNavigation();
    const navState = navigation?.extras?.state ?? window.history.state;
    const aiDraft: any = navState?.['aiDraft'];
    if (aiDraft) {
      this.prefillLineItems = aiDraft.lineItems ?? null;
      this.prefillNotes = aiDraft.notes ?? null;
    }

    this.route.queryParams.subscribe(params => {
      if (params.prefillCustomer) {
        this.prefillCustomer = {
          name: params.prefillCustomer,
          email: params.prefillEmail ?? '',
          phone: params.prefillPhone ?? '',
          phone2: '',
          address: params.prefillAddress ?? '',
          remoteID: '',
          notes: params.prefillNotes ?? '',
          googleReviewSMS: []
        };
      }

      if (params.prompt) {
        this.prefillLineDescription = params.prompt;
      }
    });

    if (this.prefillNotes && !this.prefillLineDescription) {
      this.prefillLineDescription = this.prefillNotes;
    }

    this.route.params.subscribe(params => {

      if (params.type !== undefined) {
        this.type = params.type;
      }

      // Load existing invoice
      if (params.invoice !== undefined) {
        this.header = "Edit Invoice";
        this.type = null;

        this.invoiceService.find({number: parseInt(params.invoice)}).subscribe((r:any)=> {
          this.type = r[0].type;
          this.invoice = r[0];

          this.isLoaded = true;
        })
      } else {
        this.isLoaded = true;
      }
    });
  }

  invoiceSaved(invoice: InvoiceInterface) {
    this.router.navigate(['view-invoice', invoice.number]);
  }
}
